import { Input } from "@/components/ui/input";
import { Slider } from "@/components/ui/slider";
import { Button } from "@/components/ui/button";

interface CalculatorInputsProps {
  inputs: {
    ticketPrice: number;
    leadsPerMonth: number;
    profitMargin: number;
    closeRate: number;
  };
  handleInputChange: (field: string, value: number | string) => void;
  useExampleData: () => void;
}

export const CalculatorInputs = ({ inputs, handleInputChange, useExampleData }: CalculatorInputsProps) => {
  console.log('CalculatorInputs rendering with:', inputs);
  
  return (
    <div className="space-y-6 w-full">
      <div>
        <label className="block text-sm font-medium mb-2 text-primary">
          Average Ticket Price
        </label>
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">$</span>
          <Input
            type="number"
            value={inputs.ticketPrice}
            onChange={(e) => handleInputChange('ticketPrice', e.target.value)}
            placeholder="e.g., 1500"
            className="pl-7 h-10 sm:h-11"
            min="0"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium mb-2 text-primary">
          Number of Leads Per Month
        </label>
        <Input
          type="number"
          value={inputs.leadsPerMonth}
          onChange={(e) => handleInputChange('leadsPerMonth', e.target.value)}
          placeholder="e.g., 12"
          className="h-10 sm:h-11"
          min="0"
        />
      </div>

      <div className="touch-none">
        <label className="block text-sm font-medium mb-2 text-primary">
          Profit Margin: {inputs.profitMargin}%
        </label>
        <Slider
          value={[inputs.profitMargin]}
          onValueChange={(value) => handleInputChange('profitMargin', value[0])}
          max={100}
          step={1}
          className="my-4"
          aria-label="Profit Margin"
        />
      </div>

      <div className="touch-none">
        <label className="block text-sm font-medium mb-2 text-primary">
          Close Rate: {inputs.closeRate}%
        </label>
        <Slider
          value={[inputs.closeRate]}
          onValueChange={(value) => handleInputChange('closeRate', value[0])}
          max={100}
          step={1}
          className="my-4"
          aria-label="Close Rate"
        />
      </div>

      <Button 
        onClick={useExampleData} 
        variant="outline" 
        className="w-full border-primary/20 hover:bg-primary/5 text-sm sm:text-base py-2 h-auto"
      >
        Use Example Data
      </Button>
    </div>
  );
};